



































import { Guard } from "@/store/mobile/types";
import { namespace } from "vuex-class";
import { Component, Emit, Vue } from "vue-property-decorator";

const Mobile = namespace("mobile");

@Component
export default class CoverRequest extends Vue {
	@Mobile.State CoverRequest: Guard;
	@Mobile.Action rejectCover: (guardId: number) => void;
	@Mobile.Action acceptCover: (guardId: number) => void;

	@Emit("logout")
	public async accept(guardId: number): Promise<void> {
		await this.acceptCover(guardId);
	}
}
